import { render, staticRenderFns } from "./IdSearchResult.vue?vue&type=template&id=03fa74a3&scoped=true&"
import script from "./IdSearchResult.vue?vue&type=script&lang=js&"
export * from "./IdSearchResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fa74a3",
  null
  
)

export default component.exports